export default __webpack_public_path__ + "static/media/GreatWork.3e8bb684.svg";